import React from 'react'
import { OutdatedLink } from '../../../components/OutdatedLink/OutdatedLink'

const OutdatedLinkPage = () => {
  return <OutdatedLink />
}

export default OutdatedLinkPage
